<template>
    <div>



<!-- <app-monev_topbar></app-monev_topbar>
<app-monev_left_sidebar></app-monev_left_sidebar> -->

<section class="content">
  <!-- <h1>aaa</h1> -->
<div class="container-fluid">

       <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Modul Simpeg</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons" title="Tambah Data">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th class="text-center" style="width: 80%">Nama Modul</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.modul_simpeg_id">
                            <td class="text-center">{{index+1}}.</td>
                            <td>{{data.nama_modul}}</td>
                            
                            <td class="text-center" >
                                    <button @click="selectData(data)" type="button" class="btn bg-blue btn-xs waves-effect" id="lihat_dokumen"  data-toggle="modal" data-target="#m_lihat_data">
                                        <i class="material-icons" >search</i>
                                    </button>
                                    &nbsp;
                                    <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                        <i class="material-icons" >create</i>
                                    </button>
                                    &nbsp;
                                    <button @click="removeData(data.modul_simpeg_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                        <i class="material-icons" >clear</i>
                                    </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <hr>

        <!-- ============================================================ LIHAT DATA ======================================================================== -->
            <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-md" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-blue">
                            <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                        </div>
                            <div class="modal-body">
                              <div class="table-responsive">
                                <!-- <div>
                                  <input type="checkbox" @change="check_pilihan" v-model="check_semua" id="check_semua" class="filled-in" ><label for="check_semua"><b>PILIH SEMUA</b></label> <br>
                                </div> -->
                                <input type="checkbox" v-model="dataku.registrator" id="registrator" class="filled-in" disabled><label for="registrator"><b>REGISTRASI USER</b></label> &nbsp; &nbsp;
                                <input type="checkbox" v-model="dataku.akses_semua_unit" id="check_semua" class="filled-in" disabled><label for="check_semua"><b>AKSES SEMUA UNIT KERJA</b></label> 
                                <hr>
                                <table style="width: 100%">
                                  <tr>
                                      <td style="width: 50%">
                                          <div class="demo-radio-button">
                                              <div class="demo-checkbox">
                                                  <input type="checkbox" v-model="dataku.biodata_pegawai" id="biodata_pegawai" class="filled-in" disabled><label for="biodata_pegawai">Biodata pegawai</label> <br>
                                                  <input type="checkbox" v-model="dataku.karpeg" id="karpeg" class="filled-in" disabled><label for="karpeg">Karpeg</label><br>
                                                  <input type="checkbox" v-model="dataku.skp" id="skp" class="filled-in" disabled><label for="skp">SKP</label><br>
                                                  <input type="checkbox" v-model="dataku.sk_pengangkatan" id="sk_pengangkatan" class="filled-in" disabled><label for="sk_pengangkatan">SK Pengangkatan</label><br>
                                                  <input type="checkbox" v-model="dataku.sk_kepangkatan" id="sk_kepangkatan" class="filled-in" disabled><label for="sk_kepangkatan">SK Kepangkatan</label> <br>
                                                  <input type="checkbox" v-model="dataku.jabatan_struktural" id="jabatan_struktural" class="filled-in" disabled><label for="jabatan_struktural">Jabatan Struktural</label><br>
                                                  <input type="checkbox" v-model="dataku.jabatan_fungsional" id="jabatan_fungsional" class="filled-in" disabled><label for="jabatan_fungsional">Jabatan Fungsional</label><br>
                                                  <input type="checkbox" v-model="dataku.penghargaan" id="penghargaan" class="filled-in" disabled><label for="penghargaan">Penghargaan</label><br>
                                                  <input type="checkbox" v-model="dataku.pengalaman" id="pengalaman" class="filled-in" disabled><label for="pengalaman">Riwayat Pengalaman</label><br>
                                                  <input type="checkbox" v-model="dataku.organisasi" id="organisasi" class="filled-in" disabled><label for="organisasi">Riwayat Organisasi</label> <br>
                                              </div>
                                          </div>
                                      </td>

                                      <td style="width: 50%">
                                          <div class="demo-radio-button">
                                              <div class="demo-checkbox">
                                                  
                                                  <input type="checkbox" v-model="dataku.cuti" id="cuti" class="filled-in" disabled><label for="cuti">Riwayat Cuti</label><br>
                                                  <input type="checkbox" v-model="dataku.karsi_karsu" id="karsi_karsu" class="filled-in" disabled><label for="karsi_karsu">Karsi/Karsu</label><br>
                                                  <input type="checkbox" v-model="dataku.data_anak" id="data_anak" class="filled-in" disabled><label for="data_anak">Riwayat Data Anak</label><br>
                                                  <input type="checkbox" v-model="dataku.pendidikan_formal" id="pendidikan_formal" class="filled-in" disabled><label for="pendidikan_formal">Riwayat Pendidikan Formal</label> <br>
                                                  <input type="checkbox" v-model="dataku.diklat_fungsional" id="diklat_fungsional" class="filled-in" disabled><label for="diklat_fungsional">Riwayat Diklat Fungsional</label><br>
                                                  <input type="checkbox" v-model="dataku.diklat_struktural" id="diklat_struktural" class="filled-in" disabled><label for="diklat_struktural">Riwayat Diklat Struktural</label><br>
                                                  <input type="checkbox" v-model="dataku.instansi" id="instansi" class="filled-in" disabled><label for="instansi">Instansi</label><br>
                                                  <input type="checkbox" v-model="dataku.unit_kerja" id="unit_kerja" class="filled-in" disabled><label for="unit_kerja">Unit Kerja</label><br>
                                                  <input type="checkbox" v-model="dataku.jabatan" id="jabatan" class="filled-in" disabled><label for="jabatan">Jabatan</label> <br>
                                              </div>
                                          </div>
                                      </td>
                                  </tr>
                              </table>

                               
                              </div>


                                
                            </div>
                                <hr>
                            <div class="modal-footer">
                                <!-- <button type="submit" class="btn btn-info waves-effect">SIMPAN</button> -->
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>

                    </div>
                </div>
            </div>
        <!-- ============================================================ LIHAT DATA ======================================================================== -->



        <!-- ============================================================ TAMBAH DATA ======================================================================== -->
            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                <div class="modal-dialog modal-md" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-blue">
                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                        </div>
                          <form @submit.prevent="addData()">
                            <div class="modal-body">


                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Level</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="dataku.nama_modul" type="text" id="nilai" class="form-control" placeholder="Level User">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="row clearfix">
                                  <div class="col-md-12">
                                        <div class="table-responsive">
                                            <div>
                                                <input type="checkbox" @change="check_pilihan" v-model="check_semua" id="check_semua_tambah" class="filled-in" ><label for="check_semua_tambah"><b>PILIH SEMUA</b></label> &nbsp; &nbsp;
                                                <input type="checkbox" v-model="dataku.registrator" id="registrator_tambah" class="filled-in" ><label for="registrator_tambah"><b>REGISTRASI USER</b></label> &nbsp; &nbsp;
                                                <input type="checkbox" v-model="dataku.akses_semua_unit" id="akses_semua_unit_tambah" class="filled-in" ><label for="akses_semua_unit_tambah"><b>AKSES SEMUA UNIT KERJA</b></label> 
                                            </div>
                                            <hr>
                                            <table style="width: 100%">
                                                <tr>
                                                    <td style="width: 50%">
                                                        <div class="demo-radio-button">
                                                            <div class="demo-checkbox">
                                                                <input type="checkbox" v-model="dataku.biodata_pegawai" id="biodata_pegawai_tambah" class="filled-in" ><label for="biodata_pegawai_tambah">Biodata pegawai</label> <br>
                                                                <input type="checkbox" v-model="dataku.karpeg" id="karpeg_tambah" class="filled-in" ><label for="karpeg_tambah">Karpeg</label><br>
                                                                <input type="checkbox" v-model="dataku.skp" id="skp_tambah" class="filled-in" ><label for="skp_tambah">SKP</label><br>
                                                                <input type="checkbox" v-model="dataku.sk_pengangkatan" id="sk_pengangkatan_tambah" class="filled-in" ><label for="sk_pengangkatan_tambah">SK Pengangkatan</label><br>
                                                                <input type="checkbox" v-model="dataku.sk_kepangkatan" id="sk_kepangkatan_tambah" class="filled-in" ><label for="sk_kepangkatan_tambah">SK Kepangkatan</label> <br>
                                                                <input type="checkbox" v-model="dataku.jabatan_struktural" id="jabatan_struktural_tambah" class="filled-in" ><label for="jabatan_struktural_tambah">Jabatan Struktural</label><br>
                                                                <input type="checkbox" v-model="dataku.jabatan_fungsional" id="jabatan_fungsional_tambah" class="filled-in" ><label for="jabatan_fungsional_tambah">Jabatan Fungsional</label><br>
                                                                <input type="checkbox" v-model="dataku.penghargaan" id="penghargaan_tambah" class="filled-in" ><label for="penghargaan_tambah">Penghargaan</label><br>
                                                                <input type="checkbox" v-model="dataku.pengalaman" id="pengalaman_tambah" class="filled-in" ><label for="pengalaman_tambah">Riwayat Pengalaman</label><br>
                                                                <input type="checkbox" v-model="dataku.organisasi" id="organisasi_tambah" class="filled-in" ><label for="organisasi_tambah">Riwayat Organisasi</label> <br>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td style="width: 50%">
                                                        <div class="demo-radio-button">
                                                            <div class="demo-checkbox">
                                                                <input type="checkbox" v-model="dataku.cuti" id="cuti_tambah" class="filled-in" ><label for="cuti_tambah">Riwayat Cuti</label><br>
                                                                <input type="checkbox" v-model="dataku.karsi_karsu" id="karsi_karsu_tambah" class="filled-in" ><label for="karsi_karsu_tambah">Karsi/Karsu</label><br>
                                                                <input type="checkbox" v-model="dataku.data_anak" id="data_anak_tambah" class="filled-in" ><label for="data_anak_tambah">Riwayat Data Anak</label><br>
                                                                <input type="checkbox" v-model="dataku.pendidikan_formal" id="pendidikan_formal_tambah" class="filled-in" ><label for="pendidikan_formal_tambah">Riwayat Pendidikan Formal</label> <br>
                                                                <input type="checkbox" v-model="dataku.diklat_fungsional" id="diklat_fungsional_tambah" class="filled-in" ><label for="diklat_fungsional_tambah">Riwayat Diklat Fungsional</label><br>
                                                                <input type="checkbox" v-model="dataku.diklat_struktural" id="diklat_struktural_tambah" class="filled-in" ><label for="diklat_struktural_tambah">Riwayat Diklat Struktural</label><br>
                                                                <input type="checkbox" v-model="dataku.instansi" id="instansi_tambah" class="filled-in" ><label for="instansi_tambah">Instansi</label><br>
                                                                <input type="checkbox" v-model="dataku.unit_kerja" id="unit_kerja_tambah" class="filled-in" ><label for="unit_kerja_tambah">Unit Kerja</label><br>
                                                                <input type="checkbox" v-model="dataku.jabatan" id="jabatan_tambah" class="filled-in" ><label for="jabatan_tambah">Jabatan</label> <br>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        
                                  </div>
                                </div>

                                
                            </div>
                            <div class="modal-footer">
                                <hr>
                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                          </form>
                    </div>
                </div>
            </div>
        <!-- ============================================================ TAMBAH DATA ======================================================================== -->



        <!-- ============================================================ EDIT DATA ======================================================================== -->

            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog"  data-backdrop="static">
                <div class="modal-dialog modal-md" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-green">
                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                        </div>
                        <div class="modal-body">

                            <div class="row clearfix">
                                <div class="col-md-12">
                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Level</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="dataku.nama_modul" type="text" id="nilai" class="form-control" placeholder="Level User">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="row clearfix">
                                  <div class="col-md-12">
                                        <div class="table-responsive">
                                          <div>
                                              <input type="checkbox" @change="check_pilihan" v-model="check_semua" id="check_semua_edit" class="filled-in" ><label for="check_semua_edit"><b>PILIH SEMUA</b></label> &nbsp; &nbsp;
                                              <input type="checkbox" v-model="dataku.registrator" id="registrator_edit" class="filled-in" ><label for="registrator_edit"><b>REGISTRASI USER</b></label> &nbsp; &nbsp;
                                              <input type="checkbox" v-model="dataku.akses_semua_unit" id="akses_semua_unit_edit" class="filled-in" ><label for="akses_semua_unit_edit"><b>AKSES SEMUA UNIT KERJA</b></label> 
                                          </div>
                                          <hr>
                                          <table style="width: 100%">
                                              <tr>
                                                  <td style="width: 50%">
                                                      <div class="demo-radio-button">
                                                          <div class="demo-checkbox">
                                                              <input type="checkbox" v-model="dataku.biodata_pegawai" id="biodata_pegawai_edit" class="filled-in" ><label for="biodata_pegawai_edit">Biodata pegawai</label> <br>
                                                              <input type="checkbox" v-model="dataku.karpeg" id="karpeg_edit" class="filled-in" ><label for="karpeg_edit">Karpeg</label><br>
                                                              <input type="checkbox" v-model="dataku.skp" id="skp_edit" class="filled-in" ><label for="skp_edit">SKP</label><br>
                                                              <input type="checkbox" v-model="dataku.sk_pengangkatan" id="sk_pengangkatan_edit" class="filled-in" ><label for="sk_pengangkatan_edit">SK Pengangkatan</label><br>
                                                              <input type="checkbox" v-model="dataku.sk_kepangkatan" id="sk_kepangkatan_edit" class="filled-in" ><label for="sk_kepangkatan_edit">SK Kepangkatan</label> <br>
                                                              <input type="checkbox" v-model="dataku.jabatan_struktural" id="jabatan_struktural_edit" class="filled-in" ><label for="jabatan_struktural_edit">Jabatan Struktural</label><br>
                                                              <input type="checkbox" v-model="dataku.jabatan_fungsional" id="jabatan_fungsional_edit" class="filled-in" ><label for="jabatan_fungsional_edit">Jabatan Fungsional</label><br>
                                                              <input type="checkbox" v-model="dataku.penghargaan" id="penghargaan_edit" class="filled-in" ><label for="penghargaan_edit">Penghargaan</label><br>
                                                              <input type="checkbox" v-model="dataku.pengalaman" id="pengalaman_edit" class="filled-in" ><label for="pengalaman_edit">Riwayat Pengalaman</label><br>
                                                              <input type="checkbox" v-model="dataku.organisasi" id="organisasi_edit" class="filled-in" ><label for="organisasi_edit">Riwayat Organisasi</label> <br>
                                                          </div>
                                                      </div>
                                                  </td>

                                                  <td style="width: 50%">
                                                      <div class="demo-radio-button">
                                                          <div class="demo-checkbox">
                                                              
                                                              <input type="checkbox" v-model="dataku.cuti" id="cuti_edit" class="filled-in" ><label for="cuti_edit">Riwayat Cuti</label><br>
                                                              <input type="checkbox" v-model="dataku.karsi_karsu" id="karsi_karsu_edit" class="filled-in" ><label for="karsi_karsu_edit">Karsi/Karsu</label><br>
                                                              <input type="checkbox" v-model="dataku.data_anak" id="data_anak_edit" class="filled-in" ><label for="data_anak_edit">Riwayat Data Anak</label><br>
                                                              <input type="checkbox" v-model="dataku.pendidikan_formal" id="pendidikan_formal_edit" class="filled-in" ><label for="pendidikan_formal_edit">Riwayat Pendidikan Formal</label> <br>
                                                              <input type="checkbox" v-model="dataku.diklat_fungsional" id="diklat_fungsional_edit" class="filled-in" ><label for="diklat_fungsional_edit">Riwayat Diklat Fungsional</label><br>
                                                              <input type="checkbox" v-model="dataku.diklat_struktural" id="diklat_struktural_edit" class="filled-in" ><label for="diklat_struktural_edit">Riwayat Diklat Struktural</label><br>
                                                              <input type="checkbox" v-model="dataku.instansi" id="instansi_edit" class="filled-in" ><label for="instansi_edit">Instansi</label><br>
                                                              <input type="checkbox" v-model="dataku.unit_kerja" id="unit_kerja_edit" class="filled-in" ><label for="unit_kerja_edit">Unit Kerja</label><br>
                                                              <input type="checkbox" v-model="dataku.jabatan" id="jabatan_edit" class="filled-in" ><label for="jabatan_edit">Jabatan</label> <br>
                                                          </div>
                                                      </div>
                                                  </td>
                                              </tr>
                                          </table>
                                      </div>
                                      
                                </div>
                              </div>
                                    
                                </div>
                            </div>



                                
                        </div>
                        <div class="modal-footer">
                            <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                        </div>
                    </div>
                </div>
            </div>
        <!-- ============================================================ EDIT DATA ======================================================================== -->


        </div>
      </div>

        </div>
      </section>
  </div>




</template>


<script>

// import Autocomplete from 'vue2-autocomplete-js'

const ADD_URL = URL_APP + 'api/v1/reg_modul_simpeg/';

    export default {
      // components: { Autocomplete },
        name: 'monev_wilayah',
            data () {
            return {
                dataku: {
                  modul_simpeg_id : '',
                  nama_modul : '',
                  akses_semua_unit : false,
                  registrator : false,
                  biodata_pegawai : false,
                  karpeg : false,
                  skp : false,
                  sk_pengangkatan : false,
                  sk_kepangkatan : false,
                  jabatan_struktural : false,
                  jabatan_fungsional : false,
                  penghargaan : false,
                  pengalaman : false,
                  organisasi : false,
                  cuti : false,
                  karsi_karsu : false,
                  data_anak : false,
                  pendidikan_formal : false,
                  diklat_fungsional : false,
                  diklat_struktural : false,
                  instansi : false,
                  unit_kerja : false,
                  jabatan : false

                },
                check_semua : false,
                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
            }
        },

        mounted : function(){
          this.getData();
          this.autocompleted();
        },

        methods : {
          getData : function(){

            fetch(ADD_URL+'view_data', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({
                data_ke : this.page_first,
                cari_value : this.cari_value

              })
            }).then((res) => res.json())
              .then ((res_data) => {
                this.list_data = res_data;
                // this.page_last = res_data.jml_data
                console.log(res_data);
              })

          },

          addData : function(){
            fetch (ADD_URL+'create', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify(this.dataku)
            }).then(res => res.json())
              .then((res_wilayah) => {
                // this.list_wilayah.unshift(res_wilayah);
                // console.log(res_wilayah);
                this.getData();
                this.alertku('success', 'sukses menambah data')
              })
          },


          removeData : function(id){
            fetch(ADD_URL+'remove', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({id : id})
            }).then((res_wilayah)=>{
              this.getData();
              this.alertku('success', 'sukses menghapus data')
            })
          },

          editData : function(){
            fetch (ADD_URL+'update', {
              method : 'POST',
              headers : {
                'content-type' : 'application/json',
                authorization : 'kikensbatara '+localStorage.token,
              },
              body : JSON.stringify(this.dataku)
            }).then((res_wilayah)=>{
              this.getData();
              this.alertku('success', 'sukses merubah data')
            })
          },

          selectData : function(data){
            console.log(data);
            this.dataku = {
                  modul_simpeg_id : data.modul_simpeg_id,
                  nama_modul : data.nama_modul,
                  akses_semua_unit : data.akses_semua_unit,
                  registrator : data.registrator,
                  biodata_pegawai : data.biodata_pegawai,
                  karpeg : data.karpeg,
                  skp : data.skp,
                  sk_pengangkatan : data.sk_pengangkatan,
                  sk_kepangkatan : data.sk_kepangkatan,
                  jabatan_struktural : data.jabatan_struktural,
                  jabatan_fungsional : data.jabatan_fungsional,
                  penghargaan : data.penghargaan,
                  pengalaman : data.pengalaman,
                  organisasi : data.organisasi,
                  cuti : data.cuti,
                  karsi_karsu : data.karsi_karsu,
                  data_anak : data.data_anak,
                  pendidikan_formal : data.pendidikan_formal,
                  diklat_fungsional : data.diklat_fungsional,
                  diklat_struktural : data.diklat_struktural,
                  instansi : data.instansi,
                  unit_kerja : data.unit_kerja,
                  jabatan : data.jabatan,
                }
          },

          autocompleted : function(){

            $.ajax({
              url: URL_APP+'api/v1/program/',
              type: "GET",
              headers : {
                'content-type' : 'application/json',
                authorization : 'kikensbatara '+localStorage.token,
              },
              success: function(result){
                horsey(document.querySelector('#instansi'), {
                  source: [{ list: result }],
                  getText: 'uraian',
                  getValue: 'uraian',
                  predictNextSearch(info) {
                    document.getElementById('id_instansi').value= info.selection._id ;
                    document.getElementById('id_ins').value= info.selection.uraian ;
                  },
                  limit: 2
                });
            }});

          },


          check_pilihan : function(){
              this.dataku.akses_semua_unit = this.check_semua;
              this.dataku.registrator = this.check_semua;
              this.dataku.biodata_pegawai = this.check_semua;
              this.dataku.karpeg = this.check_semua;
              this.dataku.skp = this.check_semua;
              this.dataku.sk_pengangkatan = this.check_semua;
              this.dataku.sk_kepangkatan = this.check_semua;
              this.dataku.jabatan_struktural = this.check_semua;
              this.dataku.jabatan_fungsional = this.check_semua;
              this.dataku.penghargaan = this.check_semua;
              this.dataku.pengalaman = this.check_semua;
              this.dataku.organisasi = this.check_semua;
              this.dataku.cuti = this.check_semua;
              this.dataku.karsi_karsu = this.check_semua;
              this.dataku.data_anak = this.check_semua;
              this.dataku.pendidikan_formal = this.check_semua;
              this.dataku.diklat_fungsional = this.check_semua;
              this.dataku.diklat_struktural = this.check_semua;
              this.dataku.instansi = this.check_semua;
              this.dataku.unit_kerja = this.check_semua;
              this.dataku.jabatan = this.check_semua;
          },






          // ================== PAGINASI ====================
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
              this.getData();
            },

          // ================== PAGINASI ====================
        },

    }
</script>
